import axios from "axios";

const baseURL = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL });

// Attach JWT (if present) to every admin request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tnt_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 from /api/admin/*, clear token + bounce to login.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && url.includes("/api/admin/")) {
      localStorage.removeItem("tnt_admin_token");
      if (
        typeof window !== "undefined" &&
        !window.location.pathname.startsWith("/admin/login")
      ) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  },
);

export function apiErrorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return String(detail);
}

// Helper to turn a backend image_url like "/uploads/abc.jpg" into a full URL.
export function imageUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/uploads/")) return `${baseURL}${path}`;
  return path; // local /images/... paths from /public
}

export default api;
